/* Reported live: on the product page, the sticky product photo (desktop,
   >=750px) can be taller than the space available between the sticky
   header and the bottom of the viewport. While position:sticky holds the
   photo pinned near the top during scroll, that overflow (usually the
   model's feet/shoes) stayed permanently below the fold for the whole
   "stuck" phase of the scroll.

   First attempt dropped position:sticky back to static flow whenever the
   photo didn't fit - user confirmed that revealed the feet, but then
   asked for the sticky behaviour to stay, matching the live Impulse
   reference (checked assets/theme.css.liquid on the main branch:
   ".product-single__sticky { position:sticky; top:20px/140px }" - dead
   simple, no fallback, because Impulse's own photos apparently never
   needed one).

   Second attempt tried capping the photo's own height with inline
   max-height on .media (the padding-top-percentage aspect-ratio box
   that drives the photo's size). Live testing showed Chromium does NOT
   respect max-height on that specific element - every ANCESTOR element
   honoured an inline max-height just fine, but .media itself stayed at
   its full padding-driven height no matter what (confirmed by setting
   max-height directly on .media alone vs. on its wrapping elements in
   the same test). Likely a quirk of max-height interacting with a
   percentage-padding-driven intrinsic size specifically.

   Fix that actually works: since .media's height is `padding-top:
   var(--ratio-percent)` - a PERCENTAGE OF ITS OWN WIDTH - we shrink the
   WIDTH of its ancestor .product-media-container instead (which Dawn
   otherwise forces to width:100% of the column via an earlier fix) by
   exactly the amount needed so the resulting padding-driven height
   lands at or under the available sticky window. Confirmed live: setting
   .product-media-container's width to (availableHeight * aspectRatio)
   produces a .media box that fits exactly, no scroll, no crop, sticky
   stays sticky throughout. On viewports where the photo already fits at
   full width (the common case), nothing is touched. */
(function () {
  var BOTTOM_BREATHING_ROOM = 16;

  function getGallery() {
    return document.querySelector('media-gallery.product__column-sticky');
  }

  function getActiveParts(gallery) {
    if (!gallery) return null;
    var activeItem = gallery.querySelector('.product__media-item.is-active') || gallery.querySelector('.product__media-item');
    if (!activeItem) return null;
    var container = activeItem.querySelector('.product-media-container');
    if (!container) return null;
    var img = container.querySelector('.media > img');
    if (!img) return null;
    return { container: container, img: img };
  }

  /* UPDATE: the earlier approach (shrink the photo's WIDTH until its full
     height fit the sticky window) left a big white gutter beside the
     photo on wide-but-short desktop windows, and visibly "jumped" - the
     page first rendered the wide photo, then ~1s later this script shrank
     it. Explicit request: keep the wide photo, desktop only.
     New approach: never touch the photo's size. If the gallery is taller
     than the space below the sticky header, give the sticky element a
     NEGATIVE top offset instead, so it scrolls naturally until its BOTTOM
     edge reaches the bottom of the window and only then sticks - the
     photo stays full-width, sticky still works, and the feet/hem are
     visible while it's stuck (the original reason for this script). */
  function check() {
    var gallery = getGallery();
    if (!gallery) return;

    // Clear every override from earlier versions/runs so we measure the
    // natural state each time.
    gallery.style.removeProperty('top');
    var parts = getActiveParts(gallery);
    if (parts) parts.container.style.removeProperty('width');
    var infoEl = document.querySelector('.product__info-wrapper');
    if (infoEl) {
      infoEl.style.removeProperty('margin-left');
      infoEl.style.removeProperty('width');
      infoEl.style.removeProperty('max-width');
    }

    if (window.innerWidth < 750) return;

    var defaultTop = parseFloat(getComputedStyle(gallery).top) || 0;
    var galleryHeight = gallery.getBoundingClientRect().height;
    if (!galleryHeight) return;

    if (defaultTop + galleryHeight + BOTTOM_BREATHING_ROOM > window.innerHeight) {
      var negativeTop = window.innerHeight - galleryHeight - BOTTOM_BREATHING_ROOM;
      gallery.style.setProperty('top', negativeTop + 'px', 'important');
    }
  }

  var resizeTimer;
  function scheduleCheck() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(check, 150);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', check);
  } else {
    check();
  }
  window.addEventListener('load', check);
  window.addEventListener('resize', scheduleCheck);

  // Re-check when the active media item swaps (colour/variant change,
  // thumbnail click) - these toggle the "is-active" class rather than
  // reloading the page.
  var gallery = getGallery();
  if (gallery && window.MutationObserver) {
    var observer = new MutationObserver(scheduleCheck);
    observer.observe(gallery, { attributes: true, attributeFilter: ['class'], subtree: true });
  }
})();
